import React from "react";
import Footer from "../../Share/Footer";
import PageTitle from "../../Share/PageTitle";

const Acheivements = () => {
  return (
    <>
      <PageTitle title="Acheivements"></PageTitle>
      {/* End pagetitle */}

      <section className="bg-white  lg:rounded-2xl dark:bg-[#111111]">
        <div data-aos="fade">
          <div className="container  sm:px-5 md:px-10 lg:px-20">
            <div className="py-12 px-4 mt-12">
              {/*page title here */}
              <h2 className="after-effect after:left-72 mb-[40px] mt-12 lg:mt-0">
                Acheivements
              </h2>
            </div>
          </div>
          <Footer condition={false} bg={"#FFFF"} />
        </div>
      </section>
    </>
  );
};

export default Acheivements;
